<p [ngClass]="[ellipsis ? 'u-ellipsis m-0 w-100' : '' , parkIsOverride ? 'parkOverride' : '']" [innerHTML]="localization" #wrapper (click)="localizationClick($event)">
</p>
<div class="position-relative" [ngClass]="position">
    <div class="c-localization-tooltip" [innerHTML]="localization" *ngIf="showTooltip" [@enterFromLeft]></div>
</div>

